import React, {useState, useRef} from "react";
import {Modal, Button} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

export default function CopyKlaviyoEmail(props) {
    const [show, setShow] = useState(true);
    const handleClose = () => setShow(false);
    const [value, setValue] = useState("");
    const textAreaRef = useRef();

    const handleSubmit = () => {
            let textRef = textAreaRef.current || null;
            props.submitCallback(textRef.value);
            handleClose();
            textRef.innerHTML = "";
    };

    const onchange = (e) => {
        setValue(e.target.value);
    };
    
    return (
        <div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Merge your Creator experience with your Klaviyo template</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>1. Prepare your Klaviyo template by adding a text block with the content <b> &lt;creator/&gt; </b> to it where you want your Creator experience to be visible. <i>(Note: only one <b> &lt;creator/&gt; </b> tag can be added to your template)</i><br/>2. Export your finished template from Klaviyo and paste the HTML from it in the open space below.
                    <br/>3. Paste the copied HTML into Klaviyo as a new template or email campaign.</p>
                    <textarea
                        className="html-body"
                        value={value}
                        placeholder="Paste the HTML code from your Klaviyo template"
                        id="copyhtml"
                        onChange={onchange}
                        cols={75}
                        rows={8}
                        ref={textAreaRef}
                        style={{resize: "vertical",minHeight: "100px",maxHeight: "400px", width:"100%"}}
                    ></textarea>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
         
                        <style type="text/css">
                            {`
                            .btn.disabled, .btn[disabled]:not([data-loading]){
                                background-color: #e16dff;
                                color: white;
                            }

                            .klaviyo-submit{
                                background-color: #8C01FF;
                                color: white;
                            }
                           
                            .klaviyo-submit:hover{
                                background-color: #CD00FF;
                                color: white;
                            }
                            `}
                        </style> 
                        <Button variant ="primary" className="klaviyo-submit"
                                disabled={(value.length<1)||!(/\S/.test(value))} onClick={handleSubmit}>
                                Merge and Copy
                        </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/CopyKlaviyoEmail.tsx